const rectDeg = ["0deg", "90deg", "180deg", "270deg", "360deg"];
const pentaDeg = ["0deg", "72deg", "144deg", "216deg", "288deg", "360deg"];

export default function getDegree(isRect: boolean, index: number) {
  const deg = isRect ? rectDeg : pentaDeg;

  return deg.slice(index, index + 2);
}
